export default __webpack_public_path__ + "img/62f443b4446a7323437df5154d7972ef.jpg";